import { ApiProperty } from '@nestjs/swagger';

export class VdPdfContenedorDetalleDto {
  @ApiProperty({ example: 1 })
  nro!: number;
  @ApiProperty({ example: 'CALLAO EXPRESS' })
  nave!: string;

  @ApiProperty({ example: 'HAPAG' })
  naviera!: string;

  @ApiProperty({ example: 'SAN ANTONIO' })
  pol!: string;

  @ApiProperty({ example: 'ROTTERDAM' })
  pod!: string;

  @ApiProperty({ example: '2025-02-14' })
  etd!: string; // ISO date yyyy-mm-dd

  @ApiProperty({ example: 'GRAPES' })
  especie!: string;

  @ApiProperty({ example: 'TRHU897019' })
  contenedor!: string;

  @ApiProperty({ example: 1 })
  cantidad!: number; // contenedores en la fila

  @ApiProperty({ example: 2121.0 })
  vdUsd!: number;

  @ApiProperty({ example: 2058429 })
  vdClp!: number;

  @ApiProperty({ example: 968, description: 'Tipo de cambio' })
  tc!: number;
}

export class LiquidacionVdPdfPage2Dto {
  @ApiProperty({ example: 5 })
  totalContenedores!: number;

  @ApiProperty({ example: 2121.0 })
  totalVdUsd!: number;

  @ApiProperty({ example: 2058429 })
  totalVdClp!: number;

  @ApiProperty({ type: [VdPdfContenedorDetalleDto] })
  contenedores!: VdPdfContenedorDetalleDto[];
}
